import { Form } from "antd";
import { useGlobalFilterContext } from "contexts/GlobalFilterContext";
import { isUndefined } from "lodash";
import React, { forwardRef, useEffect } from "react";
import { GithubSecretScanSupportAPI } from "restAPI/ToolsIntegrationAPI";
import { FieldTypes, generateFormFields } from "utils/formUtils";

const GithubSecretScanExperimentalFindingIngestionSelection = forwardRef(
  ({ toolName }, ref) => {
    const { globalFilterHash } = useGlobalFilterContext();
    const [form] = Form.useForm();

    useEffect(() => {
      const { cancel, promise } =
        GithubSecretScanSupportAPI.getGithubSecretScanToolConfig();
      promise.then((resData) => {
        if (!isUndefined(resData)) {
          form.setFieldsValue({expFindingIngestionToggle : [resData?.config?.expFindingIngestionToggle]});
        }
      });
      return cancel;
    }, [globalFilterHash, form]);

    const fields = [
      {
        name: "expFindingIngestionToggle",
        type: FieldTypes.CHECKBOX_GROUP,
        options: [
          {
            label: "Ingest Experimental Findings from Github Secret Scan",
            value: true,
          },
        ],
      },
    ];


    return (
        <Form
          form={form}
          ref={ref}
          style={{ minWidth: 400 }}
          layout="vertical"
        >
          {generateFormFields(fields)}
        </Form>
    );
  },
);

export default GithubSecretScanExperimentalFindingIngestionSelection;
